import { Box, Breadcrumbs, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import MentorsTable from "./MentorsTable";
import MentorAdmin from "./MentorAdmin";
import MentorPayments from "./MentorPayments";
import MentorBookings from "./MentorBookings";
import MentorAvailability from "./MentorAvailability";
import MentorSessionTypes from "./MentorSessionTypes";
import MentorSessionPackages from "./MentorSessionPackages";
import MentorStudentNotifies from "./MentorStudentNotifies";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: { xs: 1, md: 3 } }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function Mentorship() {
  const [value, setValue] = React.useState(
    Number(localStorage.getItem("mentorshipTabIndex")) || 0,
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("mentorshipTabIndex", newValue);
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: { xs: "flex-start", md: "space-between" },
          alignItems: { xs: "stretch", md: "center" },
          gap: { xs: 1, md: 0 },
          mb: 2,
          mt: 1,
          marginLeft: "10px",
        }}
      >
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
          <Link underline="hover" color="inherit" to="/booklist">
            Books List
          </Link>
          <Typography sx={{ color: "text.primary", fontWeight: 600 }}>
            Mentorship
          </Typography>
        </Breadcrumbs>
      </Box>

      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="basic tabs example"
            TabIndicatorProps={{
              style: {
                backgroundColor: "#17479e",
                height: 2,
              },
            }}
            sx={{
              "& .MuiTab-root": {
                color: "#555",
                fontWeight: 600,
                textTransform: "none",
                minWidth: "120px", // mobile friendly
              },
              "& .Mui-selected": {
                color: "#17479e !important",
              },
            }}
          >
            <Tab label="Admin" {...a11yProps(0)} />
            <Tab label="Mentors" {...a11yProps(1)} />
            <Tab label="Availability" {...a11yProps(2)} />
            <Tab label="Payments" {...a11yProps(3)} />
            <Tab label="Bookings" {...a11yProps(4)} />
            <Tab label="Session Types" {...a11yProps(5)} />
            <Tab label="Packages" {...a11yProps(6)} />
            <Tab label="Student Notifies" {...a11yProps(7)} />
            {/* <Tab label="Subjects" {...a11yProps(3)} /> */}

            {/* <Tab label="Colleges" {...a11yProps(5)} />
            <Tab label="States" {...a11yProps(6)} />
            <Tab label="Look Ups" {...a11yProps(7)} />
            <Tab label="Subject Categories" {...a11yProps(8)} /> */}
          </Tabs>
        </Box>
        <CustomTabPanel
          value={value}
          index={0}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <MentorAdmin />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={1}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <MentorsTable />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={2}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <MentorAvailability />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={3}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <MentorPayments />
        </CustomTabPanel>

        <CustomTabPanel
          value={value}
          index={4}
          style={{ overflowY: "auto", maxHeight: "92vh" }}
        >
          <MentorBookings />
        </CustomTabPanel>

        <CustomTabPanel
          value={value}
          index={5}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <MentorSessionTypes />
        </CustomTabPanel>

        <CustomTabPanel
          value={value}
          index={6}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <MentorSessionPackages />
        </CustomTabPanel>

        <CustomTabPanel
          value={value}
          index={7}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <MentorStudentNotifies />
        </CustomTabPanel>

        {/* <CustomTabPanel
          value={value}
          index={3}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          <MentorSubjects />
        </CustomTabPanel> */}
        {/*<CustomTabPanel
          value={value}
          index={6}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
         <Staets />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={7}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          {/* <Lookups />
        </CustomTabPanel>
        <CustomTabPanel
          value={value}
          index={8}
          style={{ overflowY: "auto", maxHeight: "80vh" }}
        >
          {/* <SubjectCategories />
        </CustomTabPanel> */}
      </Box>
    </>
  );
}

export default Mentorship;
